import type { Actress } from '@/mocks/actresses';

interface RankingTableProps {
  actresses: Actress[];
  scoreKey?: 'overallScore' | 'popularityScore' | 'boxOfficeScore' | 'actingScore';
}

export default function RankingTable({ actresses, scoreKey = 'overallScore' }: RankingTableProps) {
  const scoreLabels: Record<string, string> = {
    overallScore: '综合评分',
    popularityScore: '人气评分',
    boxOfficeScore: '票房评分',
    actingScore: '演技评分',
  };

  const getTrendIcon = (trend: string) => {
    if (trend === 'up') return <i className="ri-arrow-up-line text-accent-500"></i>;
    if (trend === 'down') return <i className="ri-arrow-down-line text-red-500"></i>;
    return <i className="ri-subtract-line text-foreground-400"></i>;
  };

  return (
    <div className="overflow-x-auto" data-product-shop>
      <table className="w-full text-sm">
        <thead>
          <tr className="border-b border-background-200/70">
            <th className="text-left py-3 px-4 text-foreground-500 font-medium text-xs w-16">排名</th>
            <th className="text-left py-3 px-4 text-foreground-500 font-medium text-xs">女优</th>
            <th className="text-center py-3 px-4 text-foreground-500 font-medium text-xs hidden sm:table-cell">
              {scoreLabels[scoreKey]}
            </th>
            <th className="text-center py-3 px-4 text-foreground-500 font-medium text-xs hidden md:table-cell">粉丝数</th>
            <th className="text-center py-3 px-4 text-foreground-500 font-medium text-xs hidden lg:table-cell">经纪公司</th>
            <th className="text-center py-3 px-4 text-foreground-500 font-medium text-xs w-16">趋势</th>
          </tr>
        </thead>
        <tbody>
          {actresses.map((actress, idx) => (
            <tr
              key={actress.id}
              className="border-b border-background-100/70 hover:bg-background-100/50 transition-colors"
            >
              <td className="py-3 px-4">
                <span
                  className={`inline-flex items-center justify-center w-8 h-8 rounded-full text-xs font-bold ${
                    idx < 3
                      ? 'bg-primary-500 text-background-50'
                      : 'bg-background-100 text-foreground-600'
                  }`}
                >
                  {idx + 1}
                </span>
              </td>
              <td className="py-3 px-4">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0">
                    <img
                      src={actress.avatar}
                      alt={actress.name}
                      title={`${actress.name} - 女优排行榜`}
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                  <div>
                    <p className="font-medium text-foreground-950">{actress.name}</p>
                    <p className="text-xs text-foreground-500">{actress.nameJa}</p>
                  </div>
                </div>
              </td>
              <td className="py-3 px-4 text-center hidden sm:table-cell">
                <span className="text-base font-bold text-primary-600">{actress[scoreKey]}</span>
              </td>
              <td className="py-3 px-4 text-center hidden md:table-cell">
                <span className="text-foreground-600">
                  {(actress.fansCount / 10000).toFixed(0)}万
                </span>
              </td>
              <td className="py-3 px-4 text-center hidden lg:table-cell">
                <span className="text-xs text-foreground-500">{actress.agency}</span>
              </td>
              <td className="py-3 px-4 text-center">
                <div className="flex items-center justify-center w-8 h-8 mx-auto">
                  {getTrendIcon(actress.trend)}
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}